const MS_IN_DAY = 1000 * 60 * 60 * 24;

export const formatarMoedaBR = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(valor);
};

export const formatarDataCurta = (dataISO: string | null | undefined): string => {
  if (!dataISO) return '—';
  return new Date(dataISO).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

export const formatarDataHora = (dataISO: string | null | undefined): string => {
  if (!dataISO) return '—';
  return new Date(dataISO).toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const calcularDiasParaVencimento = (dataVencimentoISO: string): number => {
  const vencimento = new Date(dataVencimentoISO).getTime();
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  return Math.ceil((vencimento - hoje.getTime()) / MS_IN_DAY);
};

export const formatarDiasVencimento = (dias: number): string => {
  if (dias > 1) return `Vence em ${dias} dias`;
  if (dias === 1) return 'Vence amanhã';
  if (dias === 0) return 'Vence hoje';
  if (dias === -1) return 'Venceu há 1 dia';
  return `Venceu há ${Math.abs(dias)} dias`;
};

export const dataAtualISO = (): string => {
  const hoje = new Date();
  return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(
    hoje.getDate(),
  ).padStart(2, '0')}`;
};
